import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Autocomplete,
  Select,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import OilBarrelIcon from "@mui/icons-material/OilBarrel";
import { data } from "./Util/PulgadasGasolina";
import tanque from "../../img/consumo.jpg";

const capacidades = ["70", "80", "100", "120", "130", "140", "150"];

export default function CalculoGalonesTanque() {
  const theme = useTheme();
  const [pulgadas, setPulgadas] = useState("");
  const [capacidadTanque, setCapacidadTanque] = useState("");
  const [resultado, setResultado] = useState("");
  const [esAproximado, setEsAproximado] = useState(false);
  const [error, setError] = useState("");
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const MIN_PULGADAS = 0;
  const MAX_PULGADAS = 22;

  useEffect(() => {
    calcularGalones();
  }, [pulgadas, capacidadTanque]);

  const calcularGalones = () => {
    setResultado("");
    setEsAproximado(false);

    if (!pulgadas || !capacidadTanque) {
      return;
    }

    const pulgadasNum = parseFloat(pulgadas);
    let registro = data.find((item) => item.PULGADAS === pulgadasNum);

    if (registro) {
      const galones = registro[capacidadTanque];
      if (galones) {
        setResultado(galones.toString());
        return;
      }
    }

    let valorMasCercano = null;
    let diferenciaMínima = Infinity;

    data.forEach((item) => {
      const diferencia = Math.abs(item.PULGADAS - pulgadasNum);
      if (diferencia < diferenciaMínima) {
        diferenciaMínima = diferencia;
        valorMasCercano = item;
      }
    });

    if (valorMasCercano) {
      const galones = valorMasCercano[capacidadTanque];
      if (galones) {
        setResultado(galones.toString());
        setEsAproximado(true);
      }
    }
  };

  const handlePulgadasChange = (event) => {
    const valor = event.target.value;

    if (!/^\d*\.?\d{0,2}$/.test(valor) && valor !== "") {
      return;
    }

    if (valor !== "") {
      const numeroValidado = parseFloat(valor);
      if (numeroValidado < MIN_PULGADAS) {
        setError(`El valor mínimo es ${MIN_PULGADAS} pulgadas`);
        setPulgadas(valor);
        return;
      }
      if (numeroValidado > MAX_PULGADAS) {
        setError(`El valor máximo es ${MAX_PULGADAS} pulgadas`);
        setPulgadas(valor);
        return;
      }
      setError("");
    } else {
      setError("");
    }

    setPulgadas(valor);
  };

  const handleCapacidadChange = (newValue) => {
    setCapacidadTanque(newValue);
  };
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <div>
      <div className="flex flex-col items-center justify-center w-full bg-cover bg-center bg-no-repeat bg-[#cc3232]">
        <br />
        <div className="flex items-center">
          <img
            src={tanque}
            alt="Tanque de Gasolina"
            className="w-16 h-16 mr-4 rounded-2xl"
          />
          <Typography
            variant={isLargeScreen ? "h3" : "h5"}
            className="text-white font-bold text-center"
            style={{ fontSize: isMobile ? "17px" : "h3" }}
          >
            Calcular Galones en Tanques
          </Typography>
        </div>
        <br />
      </div>
      <Box sx={{ p: 2, bgcolor: "white", display: "flex" }}>
        <Grid container spacing={2} sx={{ bgcolor: "white" }}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h6" className="text-center" gutterBottom>
            INGRESE LAS PULGADAS QUE MIDE EL COMBUSTIBLE EN EL TANQUE
            </Typography>
            <TextField
              label="Pulgadas en Tanques"
              variant="outlined"
              fullWidth
              value={pulgadas}
              onChange={handlePulgadasChange}
              error={!!error}
              helperText={
                error ||
                `Ingrese un valor entre ${MIN_PULGADAS} y ${MAX_PULGADAS} pulgadas`
              }
              inputProps={{
                inputMode: "decimal",
                pattern: "[0-9]*\\.?[0-9]{0,2}",
              }}
            />
          </Grid>

          <Grid item xs={14} sm={6}>
            <Typography variant="h6" className="text-center" gutterBottom>
            INDIQUE CAPACIDAD DEL TANQUE EN GALONES
            </Typography>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                options={capacidades}
                value={capacidadTanque}
                onChange={(event, newValue) => handleCapacidadChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccionar Capacidad del Tanque"
                    variant="outlined"
                    type="number"
                  />
                )}
                sx={{ display: "flex", alignItems: "center" }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ position: "relative" }}>
              {resultado && (
                <Typography className="text-center" variant="h4" gutterBottom>
                  El tanque tiene {Number(resultado).toFixed(2)}{" "}
                  galones
                </Typography>
              )}
              {!resultado && (
                <div className={`flex flex-col items-center justify-start h-full ${isLargeScreen ? '' : 'hidden'}`}>
                  <OilBarrelIcon
                    style={{ fontSize: "50px", margin: "10px" }}
                    className="text-gray-600"
                  />
                  <Typography
                    variant="h6"
                    className="text-gray-800 font-bold mb-4"
                  >
                    No hay detalles del tanque
                  </Typography>
                </div>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
